var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      !_vm.imageShown
        ? _c("DefaultCardImage", { attrs: { givenName: _vm.givenName } })
        : _vm._e(),
      _c("img", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.isImage,
            expression: "isImage",
          },
        ],
        ref: "image",
        staticClass: "object-cover",
        class: _vm.imageClasses,
        attrs: { src: _vm.filepath, alt: _vm.alt },
        on: { load: _vm.load },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }